import { MassUnit, LengthUnit } from '../enums';

export function lbsToKg(lbs: number): number {
  return lbs * MassUnit.lb / MassUnit.kg;
}

export function kgToLbs(kg: number): number {
  return kg * MassUnit.kg / MassUnit.lb;
}

export function kgToStones(kg: number): number {
  return kg * MassUnit.kg / MassUnit.st;
}

export function cmToIn(cm: number): number {
  return cm * LengthUnit.cm / LengthUnit.in;
}

export function inToCm(inches: number): number {
  return inches * LengthUnit.in / LengthUnit.cm;
}
